import { NavLink } from "react-router-dom";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import { Box, Badge } from "@mui/material";

import { ListItemText } from "./style";
import { appColors, primaryAlpha } from "../../constants/theme";

const navItemButtonSx = {
  borderRadius: "8px",
  width: "100%",
  textDecoration: "none",
  color: "text.primary",
  alignItems: "flex-start",
  whiteSpace: "normal",
  py: 1.25,
  transition: "background-color 0.15s ease, color 0.15s ease",
  "&:hover": {
    backgroundColor: primaryAlpha(0.08),
  },
  "&.active": {
    backgroundColor: primaryAlpha(0.1),
    color: appColors.primary,
    "& .MuiListItemIcon-root": {
      color: appColors.primary,
    },
    "& .MuiListItemText-root .MuiListItemText-secondary": {
      color: appColors.primary,
      fontWeight: 500,
    },
  },
  "& .MuiListItemIcon-root": {
    minWidth: 40,
    marginTop: "2px",
  },
};

const CustomRouterLink = ({ to, onClick, text, children, badgeCount }) => (
  <ListItem disablePadding sx={{ margin: "4px 8px" }}>
    <ListItemButton component={NavLink} to={to} onClick={onClick} sx={navItemButtonSx}>
      <ListItemIcon sx={{ color: "inherit", minWidth: 40 }}>
        {typeof badgeCount === "number" && badgeCount > 0 ? (
          <Badge
            badgeContent={badgeCount > 99 ? "99+" : badgeCount}
            color="error"
            overlap="rectangular"
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            sx={{
              "& .MuiBadge-badge": {
                right: -4,
                top: 4,
                fontSize: "0.65rem",
                minWidth: 18,
                height: 18,
              },
            }}
          >
            <Box component="span" sx={{ display: "inline-flex" }}>
              {children}
            </Box>
          </Badge>
        ) : (
          children
        )}
      </ListItemIcon>
      <ListItemText secondary={text} />
    </ListItemButton>
  </ListItem>
);

export default CustomRouterLink;
